<script lang="ts" setup>

</script>

<template>
  <div>
    <NuxtLinkLocale to="/dev/developers">
      <div class="sm:hidden">
        <UBadge variant="subtle" color="primary">
          XS
        </UBadge>
      </div>
      <div class="hidden sm:block md:hidden">
        <UBadge variant="subtle" color="primary">
          SM
        </UBadge>
      </div>
      <div class="hidden md:block lg:hidden">
        <UBadge variant="subtle" color="primary">
          MD
        </UBadge>
      </div>
      <div class="hidden lg:block xl:hidden">
        <UBadge variant="subtle" color="primary">
          LG
        </UBadge>
      </div>
      <div class="hidden xl:block">
        <UBadge variant="subtle" color="primary">
          XL
        </UBadge>
      </div>
    </NuxtLinkLocale>
  </div>
</template>

<style scoped>

</style>
